import React, {Component} from 'react';
import PrintPreview from '../PrintPreview'
import ReportStore from 'stores/ReportStore'
import './Print.css'

const DEFAULT_ROW = 31
class PrintReportFixingRefixed extends Component {

    constructor(...args) {
      super(...args)
        
      this.state = {loading:false,dataList:[],data:[],report_title:'กำลังดึงข้อมูล..'}

      var cssPagedMedia = (function() {
        var style = document.createElement('style');
        document.head.appendChild(style);
        return function (rule) {
          style.innerHTML = rule;
        };
      }());
  
      cssPagedMedia.size = function(size) {
        cssPagedMedia('@page {size: ' + size + '}');
      };
      cssPagedMedia.size('portrait');
    }

    componentDidMount() {
        this.loadData()
    }

    loadData() {
        if (this.props.isRange=='false'&&this.props.year!=undefined&&this.props.month!=undefined&&this.props.day!=undefined) {
            ReportStore.loadReportFixingRefixed(this.props.year,this.props.month,this.props.day,(result)=>{
                this.setState({data:result.data,dataList:this.getPagination(result.data),report_title:'ไม่พบข้อมูล'})
            },()=>{

            })   
        } else if (this.props.isRange=='true'&&this.props.startDate!=undefined&&this.props.endDate!=undefined) {
            ReportStore.loadReportFixingRefixedRange(this.props.startDate,this.props.endDate,(result)=>{
                this.setState({data:result.data,dataList:this.getPagination(result.data),report_title:'ไม่พบข้อมูล'})
            },()=>{
                
            })
        } else {
            this.setState({data:[],dataList:this.getPagination([]),report_title:'ไม่พบข้อมูล'})
        }
    }

    getNumberFormat(value) {
        let _val = value===''||value===null||value===undefined||isNaN(value) ? 0 : value
        _val = parseFloat(_val)
        return _val.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
    }
    
    getSummary() {
        let {data} = this.state
        let total = 0
        data.forEach((item,index)=> {
            total = total + (item.amount==''||item.amount==null||item.amount==undefined||isNaN(item.amount)?0:parseFloat(item.amount))
        }) 
        return total
    }

    getPagination(data) {
        let newData = []
        let allData = []
        let checkRow = 0
        data.forEach(function(item,index) {
            if (checkRow<DEFAULT_ROW)
              checkRow++
              newData.push(item)
    
            if (checkRow===DEFAULT_ROW-1||index===data.length-1) {
              allData.push(newData)
              checkRow = 0
              newData = []
            }
        })  
        
        return allData
    }

    renderRowData(data,indexs) {
        if (data.length==0) {
          return(<tr><td colSpan={9}>ไม่พบข้อมูล</td></tr>)
        } else {
          return data.map((item, index) => (
            <tr key={index}>
              <td className='text-center'>{index+1}</td>
              <td className='text-center'>{item.work_no}</td>
              <td className='text-center'>{item.car_registration_no}</td>
              <td className='text-center'>{item.model}</td>
              <td className='text-center'></td>
              <td className='text-center'>{item.detail}</td>
              <td className='text-center'>{item.problem_state}</td>
              <td className='text-center'>{item.remark}</td>
              <td className='text-center'>{item.approved_by}</td>
            </tr>
          ))
        }
    }

    renderTable(item,index,length) {
        let {type} = this.props
        return(
            <table className='table table-print-report-fixing'>
                <tbody>
                    <tr>
                        <td className='text-center' style={{width:'50px'}}>ลำดับ</td>
                        <td className='text-center' style={{width:'100px'}}>ใบงานเลขที่</td>
                        <td className='text-center' style={{width:'90px'}}>ทะเบียนรถ</td>
                        <td className='text-center' style={{width:'100px'}}>รุ่นรถ</td>
                        <td className='text-center' style={{width:'120px'}}>วันที่สร้างงานแก้ไข</td>
                        <td className='text-center' style={{width:'180px'}}>รายการซ่อม</td>
                        <td className='text-center' style={{width:'150px'}}>ขั้นตอนที่เกิดปัญหา</td>
                        <td className='text-center' style={{width:'180px'}}>หมายเหตุ</td>
                        <td className='text-center' style={{width:'150px'}}>อนุมัติโดย</td>
                    </tr>
                    {this.renderRowData(item,index)}
                </tbody>
            </table>
        )
    }

    renderComponentPage(item,index,length) {
        return(  
            <div className='font-print' key={index}>
                <header className="text-center">
                    <h2>{this.props.title}</h2>
                </header>
                <div>
                    {this.renderTable(item,index,length)}
                </div>
            </div>
        )    
    }
    
    renderNoData() {
        return(
          <div className='font-print'>
            <header className="text-center">
              <h2>{this.state.report_title}</h2>
            </header>
          </div>
        )
    }

    render() {
        let {loading,dataList} = this.state
        if (dataList.length==0) {
            return(
                <PrintPreview 
                    loading={loading}
                    leftBarTitle={this.props.title}
                >
                    {this.renderNoData()}    
                </PrintPreview>
            )
        } else {
            return(
                <PrintPreview 
                    loading={loading}
                    leftBarTitle={this.props.title}
                >
                    {
                        dataList.map((item,index)=>{
                            return(
                                this.renderComponentPage(item,index,dataList.length)
                            )
                        })   
                    }
                </PrintPreview>
            )
        }      
    }
}

PrintReportFixingRefixed.defaultProps = {
    title: 'ตารางรายงานสร้างงานซ่อมแก้ไข',
    mode: '',
    workNo: ''
  }
  export default PrintReportFixingRefixed;


// WEBPACK FOOTER //
// ./src/view/print/fixing/PrintReportFixingRefixed.js